module.exports = {
  name: 'simply',
  isSimplyBased: true,
  margintopMobile: "140px",
  margintop: "0px"
};